import * as React from 'react';
import Button from '../button';
import { ButtonProps } from "antd/lib/button";

export default function PickerButton(props: ButtonProps) {
  return <Button size="small" type="primary" {...props} />;
}



// WEBPACK FOOTER //
// ./src/components/date-picker/PickerButton.tsx